"use client";

import {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {DEFAULT_SKILLS, skillIconName, slugify} from "@repo/ui/gailgpt/skills";
import type {AgentSkill} from "@/types/skills";
import {humanizeName} from "@/utils/skills";
import type {Skill} from "./SkillCard";

/** Keep the welcome cards and composer menu on the same localized catalog. */
export function useChatSkills(apiSkills?: AgentSkill[] | null): Skill[] {
   const {t} = useTranslation("ask");

   return useMemo(() => {
      const displaySkill = (name: string, id: string, description: string): Skill => {
         const preset = DEFAULT_SKILLS[name];
         return {
            id,
            slug: slugify(name),
            icon: skillIconName(name) as Skill["icon"],
            title: preset ? t(`skills.${preset.key}.title`) : humanizeName(name),
            description: preset ? t(`skills.${preset.key}.description`) : description,
         };
      };

      return (apiSkills ?? []).map((skill) => displaySkill(skill.name, skill.id, skill.description));
   }, [apiSkills, t]);
}
